// extracted by mini-css-extract-plugin
module.exports = {"page":"ItemsTabsPage_page___8Diq","tabs":"ItemsTabsPage_tabs__1qu2q","refreshbtn":"ItemsTabsPage_refreshbtn__2BBtE"};